<template>
    <b-form-select 
        v-model="selected"
        @input="goToTeatro"
        v-if="teatros.length > 1"
    >
        <template #first>
            <b-form-select-option :value="null" disabled>Seleccione otra web para ir a ella</b-form-select-option>
        </template>
        <template v-for="teatro in teatros">
            <b-form-select-option :key="teatro.id" :value="teatro" v-if="teatro.id != teatro_actual.id">{{ teatro.nombre }}</b-form-select-option>
        </template>        
    </b-form-select>
</template>

<script>
    export default {
        data() {
            return {
                teatros: [],
                selected: null,
                options: [
                    { id: null, nombre: 'Seleccione otra web para ir a ella' }
                ]
            }
        },
        mounted() {
            this.getTeatros();
        },
        methods: {
            getTeatros() {
                let params = {filters: {}};

                this.$store.dispatch(this.config.getVuexAlias('back.usuarios.teatros'), params).then(res => {
                    this.teatros = res.data.data;
                })
            },
            goToTeatro(teatro) {
                window.location.replace(teatro.url + 'admin?api_key=' + this.api_token)
            }
        },
        computed: {
            api_token() {
                return localStorage.getItem('token');
            },
            teatro_actual() {
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>